import { useEffect, useState } from "react";
import API from "../api/api";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { useNavigate } from "react-router-dom";
import AdminLayout from "../layouts/AdminLayout";

/* ================= DATE FORMAT ================= */

const formatDateTime = (dateString) => {
  if (!dateString) return "-";

  const date = new Date(dateString);

  const weekday = date.toLocaleDateString("en-GB", {
    weekday: "long",
  });

  const day = String(date.getDate()).padStart(2, "0");

  const month = date.toLocaleDateString("en-GB", {
    month: "long",
  });

  const year = date.getFullYear();

  const time = date.toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
    hour12:false,
  });

  return `${weekday}, ${day} ${month} ${year} • ${time}`;
};



export default function Guides(){


const [guides,setGuides]=useState([]);

const [selected,setSelected]=useState(null);

const [assignments,setAssignments]=useState([]);

const [history,setHistory]=useState([]);

const [availableTours, setAvailableTours] =
    useState([]);

const [availableTotal, setAvailableTotal] =
    useState(0);

    const [tourFilter, setTourFilter] = useState("");
const [languageFilter, setLanguageFilter] = useState("");
const [dateFilter, setDateFilter] = useState("");
const [fillFilter, setFillFilter] = useState("");

const [loading,setLoading]=useState(false);

const [activeTab,setActiveTab]=useState("assigned");

const [pageTab,setPageTab]=useState("management");

  const [selectedGuide, setSelectedGuide] = useState("");
  const [availability, setAvailability] = useState([]);
  const [availableGuides, setAvailableGuides] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");
  const [viewGuide, setViewGuide] = useState(null);
  const [guideSlots, setGuideSlots] = useState([]);

  const [rateGuide, setRateGuide] = useState(null);
const [guideRates, setGuideRates] = useState([]);
const [rateTemplates, setRateTemplates] = useState([]);
const [selectedRateTemplate, setSelectedRateTemplate] = useState("");
const [showRateTemplateModal, setShowRateTemplateModal] = useState(false);
const [templateName, setTemplateName] = useState("");
const [templateRates, setTemplateRates] = useState([]);
const [rateTours, setRateTours] = useState([]);
const [savingRates, setSavingRates] = useState(false);

const primaryButton = {
    padding: "9px 14px",
    borderRadius: 8,
    border: "none",
    background: "#111827",
    color: "#fff",
    fontWeight: 600,
    cursor: "pointer"
};

const secondaryButton = {
    padding: "9px 14px",
    borderRadius: 8,
    border: "1px solid #d1d5db",
    background: "#fff",
    color: "#111827",
    fontWeight: 600,
    cursor: "pointer"
};

const navigate = useNavigate();

const availableTourTypes = [
    ...new Map(
        availableTours.map(t => [
            t.tour_id,
            {
                id: t.tour_id,
                title: t.title
            }
        ])
    ).values()
];

const availableLanguages = [
    ...new Set(
        availableTours
            .map(t => t.languages)
            .filter(Boolean)
            .flatMap(value =>
                value
                    .split(",")
                    .map(language => language.trim())
                    .filter(Boolean)
            )
    )
].sort();


/* ================= LOAD ================= */

useEffect(()=>{

loadGuides();

},[]);

useEffect(() => {
loadRateTemplates();
    loadAvailableTours();

}, [
    dateFilter,
    languageFilter,
    tourFilter,
    fillFilter
]);


/* ================= GUIDES ================= */

const loadGuides=async()=>{

try{

const res=await API.get(
"/admin/guides"
);


setGuides(
Array.isArray(res.data)
?
res.data
:
[]
);


}catch(err){

console.error(
"loadGuides error:",
err
);

setGuides([]);

}

};






/* ================= AVAILABLE TOURS ================= */

const loadAvailableTours = async () => {

    try {

        const params = {};

        if (dateFilter) {
            params.date = dateFilter;
        }

        if (languageFilter) {
            params.language = languageFilter;
        }

        if (tourFilter) {
            params.tour_id = tourFilter;
        }

        if (fillFilter) {
            params.fill = fillFilter;
        }

        params.limit = 500;


        const res = await API.get(
            "/admin/guides/available-tours",
            {
                params
            }
        );


        setAvailableTours(
            res.data.rows || []
        );


        setAvailableTotal(
            res.data.total || 0
        );


    } catch (err) {

        console.error(
            "loadAvailableTours error:",
            err
        );


        setAvailableTours([]);

    }

};






/* ================= SELECT GUIDE ================= */


const selectGuide=async(guide)=>{


setSelected(guide);

setLoading(true);


try{


const upcoming=await API.get(
`/admin/guides/${guide.id}/tours`
);


const past=await API.get(
`/admin/guides/${guide.id}/history`
);



setAssignments(
Array.isArray(upcoming.data)
?
upcoming.data
:
[]
);



setHistory(
Array.isArray(past.data)
?
past.data
:
[]
);
await loadGuideAvailability(guide.id);


}catch(err){

console.error(
"selectGuide error:",
err
);

setAssignments([]);

setHistory([]);

}


setLoading(false);


};







/* ================= ASSIGN ================= */


const assignTour=async(sessionId)=>{


try{


if(!selected)return;


await API.post(
"/admin/guides/assign",
{
guideId:selected.id,
sessionId
}
);



setAvailableTours(prev=>
prev.filter(
t=>t.id!==sessionId
)
);



selectGuide(selected);



}catch(err){

console.error(
"assignTour error:",
err
);

}

};







/* ================= UNASSIGN ================= */


const unassignTour=async(sessionId)=>{


try{


await API.post(
"/admin/guides/unassign",
{
sessionId
}
);



loadAvailableTours();


if(selected){

selectGuide(selected);

}



}catch(err){

console.error(
"unassignTour error:",
err
);

}


};




/* ================= AVAILABLITY ================= */

const loadGuideAvailability = async (guideId) => {

    if (!guideId) {
        setAvailability([]);
        return;
    }

    try {

        const res = await API.get(
            `/admin/guides/availability/${guideId}`
        );

        const rows = Array.isArray(res.data)
            ? res.data
            : [];

        setAvailability(rows);

    } catch (err) {

        console.error(err);
        setAvailability([]);

    }

};

const openGuideView = async (guide) => {

    setViewGuide(guide);

    try {

        const res = await API.get(
            `/admin/guides/availability/${guide.id}`
        );

        const slots = res.data.filter(slot =>

            slot.start_datetime.startsWith(selectedDate)

        );

        setGuideSlots(slots);

    } catch (err) {

        console.error(err);

        setGuideSlots([]);

    }

};

const handleDateClick = async (info) => {

    const date = info.dateStr.split("T")[0];

    setSelectedDate(date);

    try {

        const res = await API.get(
            "/admin/guides/availability/search",
            {
                params: {
                    date
                }
            }
        );

        setAvailableGuides(
            Array.isArray(res.data)
                ? res.data
                : []
        );

    } catch (err) {

        console.error(
            "load available guides error:",
            err
        );

        setAvailableGuides([]);

    }

};

const loadGuideRates = async (guideId) => {

    if (!guideId) {
        setGuideRates([]);
        return;
    }

    try {

        const res = await API.get(
            `/admin/guides/rates/${guideId}`
        );

        setGuideRates(
            Array.isArray(res.data)
                ? res.data
                : []
        );

    } catch (err) {

        console.error(
            "loadGuideRates error:",
            err
        );

        setGuideRates([]);

    }

};

const selectRateGuide = async (guide) => {

    setRateGuide(guide);

    await loadGuideRates(guide.id);

};

const updateGuideRate = (tourId, value) => {

    setGuideRates(prev =>
        prev.map(item =>
            item.tour_id === tourId
                ? {
                    ...item,
                    rate: value
                }
                : item
        )
    );

};

const saveGuideRates = async () => {

    if (!rateGuide) return;

    try {

        setSavingRates(true);

        await API.put(
            `/admin/guides/rates/${rateGuide.id}`,
            {
                rates: guideRates.map(item => ({
                    tour_id: item.tour_id,
                    rate: Number(item.rate)
                }))
            }
        );

        alert("Guide rates saved.");

    } catch (err) {

        console.error(
            "saveGuideRates error:",
            err
        );

        alert(
            err.response?.data?.error ||
            "Unable to save guide rates"
        );

    } finally {

        setSavingRates(false);

    }

};

const loadRateTemplates = async () => {

    try {

        const res = await API.get(
            "/admin/guides/rate-templates"
        );

        setRateTemplates(
            Array.isArray(res.data)
                ? res.data
                : []
        );

    } catch (err) {

        console.error(
            "loadRateTemplates error:",
            err
        );

        setRateTemplates([]);

    }

};

const applyRateTemplate = async () => {

    if (!rateGuide || !selectedRateTemplate) {
        return;
    }

    try {

        await API.post(
            `/admin/guides/rate-templates/${selectedRateTemplate}/apply/${rateGuide.id}`
        );

        await loadGuideRates(rateGuide.id);

        alert("Template applied.");

    } catch (err) {

        console.error(
            "applyRateTemplate error:",
            err
        );

        alert(
            err.response?.data?.error ||
            "Unable to apply template"
        );

    }

};

const openRateTemplateModal = () => {

    if (!rateGuide) {
        alert("Please select a guide first.");
        return;
    }

    const tours = Array.isArray(guideRates)
        ? guideRates
        : [];

    setTemplateRates(
        tours.map(tour => ({
            tour_id: tour.tour_id,
            title: tour.title,
            rate: tour.rate ?? 0
        }))
    );

    setTemplateName("");
    setShowRateTemplateModal(true);
};

const updateTemplateRate = (tourId, value) => {

    setTemplateRates(prev =>
        prev.map(item =>
            item.tour_id === tourId
                ? {
                    ...item,
                    rate: value
                }
                : item
        )
    );

};

const saveRateTemplate = async () => {

    if (!templateName.trim()) {
        alert("Please enter a template name.");
        return;
    }

    try {

        await API.post(
            "/admin/guides/rate-templates",
            {
                name: templateName.trim(),
                rates: templateRates.map(item => ({
                    tour_id: item.tour_id,
                    rate: Number(item.rate)
                }))
            }
        );

        alert("Rate template created.");

        setShowRateTemplateModal(false);
        setTemplateName("");
        setTemplateRates([]);

        await loadRateTemplates();

    } catch (err) {

        console.error(
            "saveRateTemplate error:",
            err
        );

        alert(
            err.response?.data?.error ||
            "Unable to create rate template"
        );

    }

};

const deleteRateTemplate = async () => {

    if (!selectedRateTemplate) {
        return;
    }

    const template = rateTemplates.find(
        t => String(t.id) === String(selectedRateTemplate)
    );

    if (!template) {
        return;
    }

    if (
        !window.confirm(
            `Delete the template "${template.name}"?`
        )
    ) {
        return;
    }

    try {

        await API.delete(
            `/admin/guides/rate-templates/${selectedRateTemplate}`
        );

        setSelectedRateTemplate("");

        await loadRateTemplates();

        alert("Template deleted.");

    } catch (err) {

        console.error(
            "deleteRateTemplate error:",
            err
        );

        alert(
            err.response?.data?.error ||
            "Unable to delete template"
        );

    }

};

return (

<AdminLayout>
<div style={page}>
  

    <div
        style={{
            display: "flex",
            alignItems: "flex-start",
            marginBottom: 22
        }}
    >
        <div>
            <h1 style={title}>Guides</h1>
            <div style={{ color: "#718096", fontSize: 13, marginTop: 5 }}>
                Manage guide assignments, availability and rates.
            </div>
        </div>
    </div>

    {/* PAGE TABS */}

    <div style={pageTabs}>

        <button
            style={{
                ...pageTabBtn,
                ...(pageTab === "management"
                    ? activePageTab
                    : {})
            }}
            onClick={() => setPageTab("management")}
        >
            👥 Guide Management
        </button>

        <button
            style={{
                ...pageTabBtn,
                ...(pageTab === "availability"
                    ? activePageTab
                    : {})
            }}
            onClick={() => setPageTab("availability")}
        >
            📅 Guide Availability
        </button>

        <button
    style={{
        ...pageTabBtn,
        ...(pageTab === "rates"
            ? activePageTab
            : {})
    }}
    onClick={() => setPageTab("rates")}
>
    💶 Guide Rates
</button>

    </div>

    {/* ================= MANAGEMENT TAB ================= */}

    {pageTab === "management" && (

        <div style={managementGrid}>

            {/* LEFT COLUMN */}

            <div style={card}>

                <h3 style={cardTitle}>
                    👨‍💼 Guides
                </h3>

                <div style={{ marginTop: 20 }}>

                    {guides.length === 0 ? (

                        <div style={empty}>
                            No guides found
                        </div>

                    ) : (

                        guides.map(g => (

                            <div
                                key={g.id}
                                onClick={() => selectGuide(g)}
                                style={{
                                    ...guideItem,
                                    ...(selected?.id === g.id
                                        ? selectedGuideStyle
                                        : {})
                                }}
                            >

                                <div style={avatar}>
                                    {g.first_name?.charAt(0)}
                                </div>

                                <div style={{ minWidth: 0, flex: 1, overflow: "hidden" }}>

                                    <div style={{ ...mainText, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                        {g.first_name} {g.last_name}
                                    </div>

                                    <div style={emailText} title={g.email || ""}>
                                        {g.email}
                                    </div>

                                </div>

                            </div>

                        ))

                    )}

                </div>

            </div>

                        {/* CENTER COLUMN */}

            <div style={card}>

                <div style={headerRow}>

                    <h3 style={cardTitle}>
                        {selected
                            ? `${selected.first_name} ${selected.last_name}`
                            : "Select a Guide"}
                    </h3>

                </div>

                {!selected ? (

                    <div style={empty}>
                        Select a guide to view assignments.
                    </div>

                ) : loading ? (

                    <div style={empty}>
                        Loading...
                    </div>

                ) : (

                    <>

                        <div style={tabs}>

                            <button
                                style={{
                                    ...tabBtn,
                                    ...(activeTab === "assigned"
                                        ? activeTabStyle
                                        : {})
                                }}
                                onClick={() => setActiveTab("assigned")}
                            >
                                📅 Upcoming
                            </button>

                            <button
                                style={{
                                    ...tabBtn,
                                    ...(activeTab === "history"
                                        ? activeTabStyle
                                        : {})
                                }}
                                onClick={() => setActiveTab("history")}
                            >
                                ✔ History
                            </button>

                        </div>

                        {activeTab === "assigned" ? (

                            assignments.length === 0 ? (

                                <div style={empty}>
                                    No upcoming assignments
                                </div>

                            ) : (

                                assignments.map(a => (

                                    <div
                                        key={a.id}
                                        style={tourCard}
                                    >

                                        <div>

                                            <div style={mainText}>
                                                {a.title}
                                            </div>

                                            <div style={smallText}>
                                                📅 {formatDateTime(a.start_datetime)}
                                            </div>

                                        </div>

                                        <button
                                            style={dangerBtn}
                                            onClick={() => unassignTour(a.id)}
                                        >
                                            Unassign
                                        </button>

                                    </div>

                                ))

                            )

                        ) : (

                            history.length === 0 ? (

                                <div style={empty}>
                                    No tour history
                                </div>

                            ) : (

                                history.map(a => (

                                    <div
                                        key={a.id}
                                        style={tourCard}
                                    >

                                        <div>

                                            <div style={mainText}>
                                                {a.title}
                                            </div>

                                            <div style={smallText}>
                                                📅 {formatDateTime(a.start_datetime)}
                                            </div>

                                        </div>

                                        <div
    style={
        a.status === "cancelled"
            ? cancelledStatus
            : completed
    }
>
    {a.status === "cancelled"
        ? "✕ Cancelled"
        : a.status === "completed"
        ? "✔ Completed"
        : "◷ Scheduled"}
</div>

                                    </div>

                                ))

                            )

                        )}

                    </>

                )}

            </div>

            {/* RIGHT COLUMN */}

            <div style={card}>

    <div style={headerRow}>

        <div>
            <h3 style={cardTitle}>
                🚀 Available Tours
            </h3>

            <div style={smallText}>
                {availableTours.length} available
            </div>
        </div>

        <div style={smallText}>
            {availableTotal}
        </div>

    </div>


    {/* ================= TOUR FILTERS ================= */}

    <div style={filterPanel}>

        {/* DATE */}

        <input
            type="date"
            value={dateFilter}
            onChange={(e) =>
                setDateFilter(e.target.value)
            }
            style={filterInput}
        />


        {/* LANGUAGE */}

        <select
            value={languageFilter}
            onChange={(e) =>
                setLanguageFilter(e.target.value)
            }
            style={filterInput}
        >

            <option value="">
                All Languages
            </option>

            {availableLanguages.map(language => (

                <option
                    key={language}
                    value={language}
                >
                    {language}
                </option>

            ))}

        </select>


        {/* TOUR */}

        <select
            value={tourFilter}
            onChange={(e) =>
                setTourFilter(e.target.value)
            }
            style={filterInput}
        >

            <option value="">
                All Tours
            </option>

            {availableTourTypes.map(tour => (

                <option
                    key={tour.id}
                    value={tour.id}
                >
                    {tour.title}
                </option>

            ))}

        </select>


        {/* FILL */}

        <select
            value={fillFilter}
            onChange={(e) =>
                setFillFilter(e.target.value)
            }
            style={filterInput}
        >

            <option value="">
                Any Group Size
            </option>

            <option value="under50">
                Under 50% full
            </option>

            <option value="50to75">
                50–75% full
            </option>

            <option value="75plus">
                75%+ full
            </option>

        </select>


        {/* RESET */}

        <button
            style={resetFilterBtn}
            onClick={() => {

                setDateFilter("");
                setLanguageFilter("");
                setTourFilter("");
                setFillFilter("");

            }}
        >
            Reset
        </button>

    </div>

                {availableTours.length === 0 ? (

                    <div style={empty}>
                        No available tours
                    </div>

                ) : (

                    availableTours.map(t => (

                       <div
    key={t.id}
    style={assignmentTourCard}
>

    {/* LEFT SIDE */}

    <div style={{ flex: 1 }}>

        <div style={assignmentTourTitle}>
            {t.title}
        </div>


        <div style={assignmentTourDate}>
            📅 {formatDateTime(t.start_datetime)}
        </div>


        {/* LANGUAGE */}

        {t.languages && (

            <div style={tourMetaRow}>

                🌐

                <span>
                    {t.languages
                        .split(",")
                        .map(l => l.trim())
                        .join(" • ")
                    }
                </span>

            </div>

        )}


        {/* GROUP */}

        <div style={tourMetaRow}>

            👥

            <span>

                {t.booked}
                {" / "}
                {t.capacity}
                {" guests"}

            </span>

        </div>


        {/* PROGRESS */}

        <div style={progressBackground}>

            <div
                style={{
                    ...progressBar,
                    width:
                        `${Math.min(
                            Number(t.fill_percent) || 0,
                            100
                        )}%`
                }}
            />

        </div>


        <div style={tourFillText}>

            {t.fill_percent}% full

            {" • "}

            {t.remaining} places left

        </div>


    </div>


    {/* ASSIGN */}

    <button
        style={assignBtn}
        onClick={() => assignTour(t.id)}
    >
        Assign
    </button>

</div>

                    ))

                )}

            </div>

        </div>

    )}

        {/* ================= AVAILABILITY TAB ================= */}

    {pageTab === "availability" && (

        <div style={card}>

            <h3 style={cardTitle}>
                📅 Guide Availability
            </h3>

            <div style={{ marginTop: 20, marginBottom: 20 }}>

                <select
                    value={selectedGuide}
                    onChange={(e) => {

                        const id = e.target.value;

                        setSelectedGuide(id);

                        loadGuideAvailability(id);

                    }}
                    style={guideSelect}
                >

                    <option value="">
                        Select a guide
                    </option>

                    {guides.map(g => (

                        <option
                            key={g.id}
                            value={g.id}
                        >
                            {g.first_name} {g.last_name}
                        </option>

                    ))}

                </select>
                

            </div>

            <div style={smallText}>
    {selectedGuide
        ? `🟢 ${availability.length} availability slots loaded`
        : "Select a guide to load their availability"
    }
</div>

<div style={{ marginTop: 20 }}>

    <FullCalendar

        plugins={[
            dayGridPlugin,
            timeGridPlugin,
            interactionPlugin
        ]}

        initialView="dayGridMonth"

        dateClick={handleDateClick}

        height={600}

        headerToolbar={{
            left: "prev,next today",
            center: "title",
            right: "dayGridMonth,timeGridWeek,timeGridDay"
        }}

        events={
            selectedGuide
                ? availability.map(a => ({
                    id: a.id,
                    title: a.title || "Available",
                    start: a.start_datetime,
                    end: a.end_datetime,
                    backgroundColor: "#22c55e",
                    borderColor: "#22c55e",
                    textColor: "#fff"
                }))
                : []
        }

    />

</div>




        </div>

    )}

    {pageTab === "rates" && (

    <div style={ratesLayoutGrid}>

        {/* GUIDE SELECTOR */}

        <div style={card}>

            <div style={ratesSectionHeader}>
                <div>
                    <h3 style={cardTitle}>Guides</h3>
                    <p style={ratesSectionHint}>Choose a guide to view and edit their tour rates.</p>
                </div>
                <span style={countPill}>{guides.length}</span>
            </div>

            <div style={ratesGuideList}>

                {guides.length === 0 ? (
                    <div style={empty}>No guides found.</div>
                ) : (

                    guides.map(guide => (

                        <div
                            key={guide.id}
                            onClick={() => selectRateGuide(guide)}
                            style={{
                                ...guideItem,
                                ...ratesGuideItem,
                                ...(rateGuide?.id === guide.id ? selectedGuideStyle : {})
                            }}
                        >

                            <div style={avatar}>
                                {guide.first_name?.charAt(0)}
                            </div>

                            <div style={ratesGuideIdentity}>
                                <div style={mainText}>
                                    {guide.first_name} {guide.last_name}
                                </div>

                                <div style={emailText} title={guide.email || ""}>
                                    {guide.email}
                                </div>
                            </div>

                            {rateGuide?.id === guide.id && (
                                <span style={selectedGuideIndicator}>Selected</span>
                            )}

                        </div>

                    ))

                )}

            </div>

        </div>


        {/* GUIDE RATE EDITOR */}

        <div style={card}>

            <div style={ratesEditorHeader}>
                <div>
                    <h3 style={cardTitle}>
                        {rateGuide
                            ? `${rateGuide.first_name} ${rateGuide.last_name}`
                            : "Guide rates"}
                    </h3>
                    <p style={ratesSectionHint}>
                        {rateGuide
                            ? "Set the payment rate for each tour."
                            : "Select a guide from the list to manage their rates."}
                    </p>
                </div>

                {rateGuide && (
                    <span style={countPill}>{guideRates.length} tours</span>
                )}
            </div>


            {!rateGuide ? (

                <div style={ratesEmptyState}>
                    <div style={ratesEmptyIcon}>€</div>
                    <div style={{ fontWeight: 700, color: "#344054", marginBottom: 5 }}>
                        No guide selected
                    </div>
                    <div style={{ fontSize: 13, color: "#718096" }}>
                        Choose a guide on the left to see their rates and templates.
                    </div>
                </div>

            ) : (

                <>

                    {/* RATE TEMPLATES */}

                    <div style={templatePanel}>
                        <div style={templatePanelHeading}>
                            <div>
                                <div style={templatePanelTitle}>Rate templates</div>
                                <div style={ratesSectionHint}>
                                    Apply a saved set of rates or create a new template.
                                </div>
                            </div>
                        </div>

                        <div style={templateActions}>
                            <select
                                value={selectedRateTemplate}
                                onChange={e => setSelectedRateTemplate(e.target.value)}
                                style={{ ...filterInput, flex: "1 1 190px" }}
                            >
                                <option value="">Select rate template</option>

                                {rateTemplates.map(template => (
                                    <option key={template.id} value={template.id}>
                                        {template.name}
                                    </option>
                                ))}
                            </select>

                            <button
                                onClick={applyRateTemplate}
                                disabled={!selectedRateTemplate}
                                style={{
                                    ...primaryButton,
                                    ...ratesActionButton,
                                    opacity: selectedRateTemplate ? 1 : 0.5,
                                    cursor: selectedRateTemplate ? "pointer" : "not-allowed"
                                }}
                            >
                                Apply
                            </button>

                            <button
                                onClick={deleteRateTemplate}
                                disabled={!selectedRateTemplate}
                                style={{
                                    ...secondaryButton,
                                    ...ratesActionButton,
                                    color: "#b74632",
                                    borderColor: "#f0c9c5",
                                    opacity: selectedRateTemplate ? 1 : 0.5,
                                    cursor: selectedRateTemplate ? "pointer" : "not-allowed"
                                }}
                            >
                                Delete
                            </button>

                            <button
                                onClick={openRateTemplateModal}
                                style={{
                                    ...secondaryButton,
                                    ...ratesActionButton
                                }}
                            >
                                + Create template
                            </button>
                        </div>
                    </div>


                    {/* TOUR RATE LIST */}

                    <div style={ratesListHeader}>
                        <div style={templatePanelTitle}>Tour rates</div>
                        <div style={ratesSectionHint}>Enter the amount paid to this guide for each tour.</div>
                    </div>

                    {guideRates.length === 0 ? (

                        <div style={empty}>
                            No tour rates found for this guide.
                        </div>

                    ) : (

                        <div style={ratesList}>
                            {guideRates.map(tour => (

                                <div key={tour.tour_id} style={rateRow}>

                                    <div style={rateTourIdentity}>
                                        <div style={rateTourName}>{tour.title}</div>
                                        <div style={rateTourCaption}>Guide payment</div>
                                    </div>

                                    <div style={rateInputGroup}>
                                        <span style={currencyPrefix}>€</span>
                                        <input
                                            type="number"
                                            min="0"
                                            step="0.01"
                                            value={tour.rate ?? ""}
                                            onChange={e =>
                                                updateGuideRate(tour.tour_id, e.target.value)
                                            }
                                            style={rateInput}
                                        />
                                    </div>

                                </div>

                            ))}
                        </div>

                    )}

                    <div style={ratesSaveBar}>
                        <span style={ratesSaveHint}>
                            Changes are applied when you save.
                        </span>

                        <button
                            onClick={saveGuideRates}
                            disabled={savingRates}
                            style={{
                                ...primaryButton,
                                ...ratesSaveButton,
                                opacity: savingRates ? 0.7 : 1,
                                cursor: savingRates ? "wait" : "pointer"
                            }}
                        >
                            {savingRates ? "Saving..." : "Save rates"}
                        </button>
                    </div>

                </>

            )}

        </div>

    </div>

)}

{showRateTemplateModal && (

    <div
        style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.45)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
            padding: 20
        }}
    >

        <div
            style={{
                background: "#fff",
                width: "100%",
                maxWidth: 700,
                maxHeight: "85vh",
                overflowY: "auto",
                borderRadius: 14,
                padding: 24,
                boxShadow: "0 20px 50px rgba(0,0,0,0.25)"
            }}
        >

            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 20
                }}
            >

                <h2 style={{ margin: 0 }}>
                    Create Rate Template
                </h2>

                <button
                    onClick={() =>
                        setShowRateTemplateModal(false)
                    }
                    style={{
                        border: "none",
                        background: "transparent",
                        fontSize: 24,
                        cursor: "pointer"
                    }}
                >
                    ×
                </button>

            </div>


            {/* TEMPLATE NAME */}

            <div style={{ marginBottom: 20 }}>

                <label
                    style={{
                        display: "block",
                        fontWeight: 600,
                        marginBottom: 8
                    }}
                >
                    Template Name
                </label>

                <input
                    type="text"
                    value={templateName}
                    onChange={e =>
                        setTemplateName(e.target.value)
                    }
                    placeholder="e.g. Standard Rates"
                    style={{
                        width: "100%",
                        boxSizing: "border-box",
                        padding: "10px 12px",
                        border: "1px solid #d1d5db",
                        borderRadius: 8,
                        fontSize: 14
                    }}
                />

            </div>


            {/* TOURS */}

            <div>

                <h3
                    style={{
                        marginBottom: 10
                    }}
                >
                    Tour Rates
                </h3>

                {templateRates.length === 0 ? (

                    <div style={empty}>
                        No tours found.
                    </div>

                ) : (

                    templateRates.map(tour => (

                        <div
                            key={tour.tour_id}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: 20,
                                padding: "12px 0",
                                borderBottom:
                                    "1px solid #e5e7eb"
                            }}
                        >

                            <div
                                style={{
                                    flex: 1,
                                    fontWeight: 600
                                }}
                            >
                                {tour.title}
                            </div>

                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 8
                                }}
                            >

                                <input
                                    type="number"
                                    min="0"
                                    step="0.01"
                                    value={tour.rate ?? ""}
                                    onChange={e =>
                                        updateTemplateRate(
                                            tour.tour_id,
                                            e.target.value
                                        )
                                    }
                                    style={{
                                        width: 110,
                                        padding: "9px 10px",
                                        border:
                                            "1px solid #d1d5db",
                                        borderRadius: 8
                                    }}
                                />

                                <span>€</span>

                            </div>

                        </div>

                    ))

                )}

            </div>


            {/* BUTTONS */}

            <div
                style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: 10,
                    marginTop: 24
                }}
            >

                <button
                    onClick={() =>
                        setShowRateTemplateModal(false)
                    }
                    style={secondaryButton}
                >
                    Cancel
                </button>

                <button
                    onClick={saveRateTemplate}
                    style={primaryButton}
                >
                    Create Template
                </button>

            </div>

        </div>

    </div>

)}
    <div style={{ marginTop: 30 }}>

    {!selectedDate ? (

        <div style={empty}>
            Click a date on the calendar to see availability.
        </div>

    ) : (

        <>

            <h3
                style={{
                    ...cardTitle,
                    marginBottom: 6
                }}
            >
                Availability
            </h3>

            <div style={smallText}>
                {selectedDate}
            </div>

            

                {availableGuides.length === 0 ? (

    <div style={empty}>
        No guides available for this date.
    </div>

) : (

    availableGuides.map(g => (

        <div
            key={g.id}
            style={guideRow}
        >

            <div style={{ minWidth: 0, flex: 1, overflow: "hidden" }}>

                <div style={{ ...mainText, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    {g.first_name} {g.last_name}
                </div>

                <div style={emailText} title={g.email || ""}>
                    {g.email}
                </div>

            </div>

            <button
                style={assignBtn}
                onClick={() => openGuideView(g)}
            >
                View
            </button>

        </div>

    ))

)}

        </>

    )}

    </div>

        {viewGuide && (

        <div style={modalOverlay}>

            <div style={modal}>

                <h3 style={cardTitle}>
                    {viewGuide.first_name} {viewGuide.last_name}
                </h3>

                <div style={modalInfo}>

                    {guideSlots.length === 0 ? (

                        <div style={empty}>
                            No availability
                        </div>

                    ) : (

                        guideSlots.map(slot => (

                            <div
                                key={slot.id}
                                style={slotCard}
                            >

                                🟢

                                {" "}

                                {new Date(
                                    slot.start_datetime
                                ).toLocaleTimeString([], {
                                    hour: "2-digit",
                                    minute: "2-digit"
                                })}

                                {" - "}

                                {new Date(
                                    slot.end_datetime
                                ).toLocaleTimeString([], {
                                    hour: "2-digit",
                                    minute: "2-digit"
                                })}

                            </div>

                        ))

                    )}

                </div>

                <div
                    style={{
                        marginTop: 20,
                        display: "flex",
                        justifyContent: "flex-end"
                    }}
                >

                    <button
                        style={closeBtn}
                        onClick={() => {

                            setViewGuide(null);
                            setGuideSlots([]);

                        }}
                    >
                        Close
                    </button>

                </div>

            </div>

        </div>

    )}

</div>
</AdminLayout>

);




}


/* ================= PARIS UNSCRIPTED CRM STYLES ================= */

const page = {
    padding: window.innerWidth < 900 ? 16 : 24,
    minHeight: "100vh",
    background: "#f5f6f8",
    color: "#172033",
    boxSizing: "border-box",
    width: "100%",
    maxWidth: 1440,
    margin: "0 auto",
    overflowX: "hidden"
};

const title = {
    color: "#172033",
    fontSize: window.innerWidth < 900 ? 25 : 26,
    fontWeight: 800,
    margin: 0,
    letterSpacing: "-0.6px"
};

const card = {
    background: "#ffffff",
    padding: window.innerWidth < 700 ? 16 : 22,
    borderRadius: 16,
    border: "1px solid #e7eaf0",
    boxShadow: "0 2px 10px rgba(15,23,42,.04)",
    minWidth: 0,
    boxSizing: "border-box"
};

const cardTitle = {
    margin: 0,
    fontSize: 17,
    fontWeight: 750,
    color: "#172033",
    letterSpacing: "-.2px"
};

const headerRow = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 12,
    marginBottom: 18
};

const badge = {
    background: "#f1f3f6",
    color: "#475569",
    padding: "5px 12px",
    borderRadius: 20,
    fontSize: 12,
    fontWeight: 700
};

const badgeOrange = {
    background: "#fff1eb",
    color: "#c75028",
    padding: "5px 12px",
    borderRadius: 20,
    fontSize: 12,
    fontWeight: 700
};

const guideItem = {
    display: "flex",
    alignItems: "center",
    gap: 12,
    minWidth: 0,
    overflow: "hidden",
    padding: 12,
    borderRadius: 12,
    marginBottom: 8,
    cursor: "pointer",
    transition: ".2s",
    border: "1px solid #e9edf2",
    background: "#fff"
};

const guideRow = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 12,
    padding: 14,
    marginBottom: 10,
    background: "#fafbfc",
    borderRadius: 12,
    border: "1px solid #e9edf2"
};

const selectedGuideStyle = {
    background: "#fff5f0",
    border: "1px solid #e9a58d",
    boxShadow: "0 0 0 2px rgba(199,80,40,.06)"
};

const avatar = {
    width: 40,
    height: 40,
    flexShrink: 0,
    borderRadius: "50%",
    background: "#c75028",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 800,
    fontSize: 16
};

const smallText = {
    fontSize: 12,
    color: "#718096",
    marginTop: 5,
    lineHeight: 1.45
};

const emailText = {
    ...smallText,
    display: "block",
    width: "100%",
    maxWidth: "100%",
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
};

const mainText = {
    fontWeight: 700,
    color: "#172033",
    fontSize: 14
};

const tabs = {
    display: "flex",
    gap: 8,
    marginBottom: 18,
    padding: 5,
    background: "#f3f5f7",
    borderRadius: 12
};

const tabBtn = {
    flex: 1,
    padding: "10px 12px",
    border: "none",
    borderRadius: 9,
    cursor: "pointer",
    background: "transparent",
    color: "#64748b",
    fontWeight: 700,
    fontSize: 13
};

const activeTabStyle = {
    background: "#fff",
    color: "#c75028",
    boxShadow: "0 1px 4px rgba(15,23,42,.10)"
};

const tourCard = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 12,
    padding: 14,
    marginBottom: 10,
    borderRadius: 12,
    background: "#fafbfc",
    border: "1px solid #e9edf2"
};

const assignBtn = {
    padding: "9px 15px",
    background: "#c75028",
    color: "#fff",
    border: "none",
    borderRadius: 9,
    cursor: "pointer",
    fontWeight: 700,
    fontSize: 13,
    whiteSpace: "nowrap"
};

const dangerBtn = {
    padding: "8px 13px",
    background: "#fff1f0",
    color: "#c2413a",
    border: "1px solid #fecaca",
    borderRadius: 9,
    cursor: "pointer",
    fontWeight: 700,
    fontSize: 12
};

const completed = {
    marginTop: 6,
    fontSize: 12,
    color: "#16845b",
    fontWeight: 700
};

const cancelledStatus = {
    marginTop: 6,
    fontSize: 12,
    color: "#c2413a",
    fontWeight: 700
};

const empty = {
    padding: 24,
    textAlign: "center",
    color: "#718096",
    background: "#f8fafc",
    border: "1px dashed #dce2e9",
    borderRadius: 12,
    fontSize: 13
};

const pageTabs = {
    display: "flex",
    flexWrap: "wrap",
    gap: 8,
    marginBottom: 22,
    padding: 5,
    background: "#e9edf1",
    borderRadius: 13,
    width: "fit-content",
    maxWidth: "100%"
};

const pageTabBtn = {
    padding: "10px 16px",
    border: "none",
    borderRadius: 9,
    background: "transparent",
    color: "#536174",
    cursor: "pointer",
    fontWeight: 700,
    fontSize: 13,
    whiteSpace: "nowrap"
};

const activePageTab = {
    background: "#fff",
    color: "#c75028",
    boxShadow: "0 1px 4px rgba(15,23,42,.10)"
};

const guideSelect = {
    width: "100%",
    boxSizing: "border-box",
    padding: "11px 12px",
    borderRadius: 9,
    border: "1px solid #d8dee7",
    fontSize: 14,
    marginTop: 12,
    marginBottom: 12,
    background: "#fff",
    color: "#172033"
};

const statusBox = {
    padding: 14,
    background: "#ecfdf5",
    borderRadius: 12,
    color: "#15803d",
    fontWeight: 600,
    marginBottom: 18
};

const modalOverlay = {
    position: "fixed",
    inset: 0,
    background: "rgba(15,23,42,.48)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
    padding: 16
};

const modal = {
    width: "100%",
    maxWidth: 440,
    boxSizing: "border-box",
    background: "#fff",
    padding: 24,
    borderRadius: 16,
    border: "1px solid #e7eaf0",
    boxShadow: "0 20px 50px rgba(15,23,42,.22)"
};

const modalInfo = {
    margin: "18px 0"
};

const slotCard = {
    padding: 12,
    marginBottom: 9,
    borderRadius: 10,
    background: "#ecfdf5",
    color: "#15803d",
    fontWeight: 600,
    fontSize: 13
};

const closeBtn = {
    padding: "9px 16px",
    background: "#f1f3f6",
    color: "#334155",
    border: "1px solid #e2e8f0",
    borderRadius: 9,
    cursor: "pointer",
    fontWeight: 700
};

const ratesLayoutGrid = {
    display: "grid",
    gridTemplateColumns: window.innerWidth < 850
        ? "minmax(0, 1fr)"
        : "minmax(250px, 310px) minmax(0, 1fr)",
    gap: 18,
    alignItems: "start"
};

const ratesSectionHeader = {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: 12,
    marginBottom: 16
};

const ratesEditorHeader = {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: 12,
    paddingBottom: 16,
    marginBottom: 16,
    borderBottom: "1px solid #edf0f3"
};

const ratesSectionHint = {
    margin: "5px 0 0",
    color: "#718096",
    fontSize: 12,
    lineHeight: 1.45
};

const countPill = {
    flexShrink: 0,
    padding: "5px 9px",
    borderRadius: 999,
    background: "#f1f3f6",
    color: "#596579",
    fontSize: 11,
    fontWeight: 700
};

const ratesGuideList = {
    display: "flex",
    flexDirection: "column",
    gap: 7,
    marginTop: 4
};

const ratesGuideItem = {
    marginBottom: 0,
    padding: "10px 11px",
    borderRadius: 10
};

const ratesGuideIdentity = {
    minWidth: 0,
    flex: 1,
    overflow: "hidden"
};

const selectedGuideIndicator = {
    flexShrink: 0,
    color: "#c75028",
    fontSize: 10,
    fontWeight: 700,
    padding: "4px 7px",
    borderRadius: 999,
    background: "#fff1eb"
};

const ratesEmptyState = {
    padding: "42px 22px",
    textAlign: "center",
    background: "#f8fafc",
    border: "1px dashed #d8dee7",
    borderRadius: 11
};

const ratesEmptyIcon = {
    width: 42,
    height: 42,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto 12px",
    borderRadius: 12,
    background: "#fff1eb",
    color: "#c75028",
    fontSize: 21,
    fontWeight: 800
};

const templatePanel = {
    padding: 15,
    marginBottom: 22,
    borderRadius: 11,
    border: "1px solid #e7eaf0",
    background: "#f8fafc"
};

const templatePanelHeading = {
    marginBottom: 12
};

const templatePanelTitle = {
    color: "#263247",
    fontSize: 14,
    fontWeight: 750
};

const templateActions = {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: 8
};

const ratesActionButton = {
    padding: "9px 12px",
    fontSize: 12,
    whiteSpace: "nowrap"
};

const ratesListHeader = {
    marginBottom: 10
};

const ratesList = {
    borderTop: "1px solid #edf0f3"
};

const rateRow = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 16,
    padding: "13px 2px",
    borderBottom: "1px solid #edf0f3"
};

const rateTourIdentity = {
    minWidth: 0,
    flex: 1
};

const rateTourName = {
    color: "#263247",
    fontSize: 13,
    lineHeight: 1.4,
    fontWeight: 650,
    overflowWrap: "anywhere"
};

const rateTourCaption = {
    marginTop: 3,
    color: "#8792a2",
    fontSize: 11
};

const rateInputGroup = {
    display: "flex",
    alignItems: "center",
    gap: 7,
    flexShrink: 0
};

const currencyPrefix = {
    color: "#718096",
    fontSize: 13,
    fontWeight: 650
};

const rateInput = {
    width: 112,
    boxSizing: "border-box",
    padding: "9px 10px",
    border: "1px solid #d5dce5",
    borderRadius: 8,
    background: "#ffffff",
    color: "#263247",
    fontSize: 13,
    textAlign: "right",
    outlineColor: "#c75028"
};

const ratesSaveBar = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: 12,
    marginTop: 18,
    paddingTop: 16,
    borderTop: "1px solid #edf0f3"
};

const ratesSaveHint = {
    color: "#8792a2",
    fontSize: 11
};

const ratesSaveButton = {
    margin: 0,
    padding: "10px 18px",
    background: "#c75028",
    borderRadius: 8
};

const managementGrid = {
    display: "grid",
    gridTemplateColumns: window.innerWidth < 1100
        ? "1fr"
        : "minmax(230px, 280px) minmax(300px, 1fr) minmax(300px, 360px)",
    gap: 18,
    alignItems: "start"
};

const availabilityGrid = {
    display: "grid",
    gridTemplateColumns: "minmax(230px, 320px) minmax(0, 1fr)",
    gap: 18,
    alignItems: "start"
};



const filterPanel = {
    display: "flex",
    flexWrap: "wrap",
    gap: 8,
    padding: 12,
    marginBottom: 16,
    background: "#f8fafc",
    borderRadius: 12,
    border: "1px solid #e7eaf0",
    boxSizing: "border-box"
};

const filterInput = {
    flex: "1 1 140px",
    minWidth: 0,
    boxSizing: "border-box",
    padding: "9px 10px",
    borderRadius: 8,
    border: "1px solid #d8dee7",
    background: "#fff",
    fontSize: 12,
    color: "#374151",
    outline: "none"
};

const resetFilterBtn = {
    flex: "0 0 auto",
    padding: "9px 12px",
    border: "1px solid #e2e8f0",
    borderRadius: 8,
    background: "#fff",
    color: "#475569",
    cursor: "pointer",
    fontWeight: 600,
    fontSize: 12
};

const assignmentTourCard = {
    display: "flex",
    gap: 15,
    alignItems: "center",
    padding: 14,
    marginBottom: 10,
    borderRadius: 12,
    background: "#fafbfc",
    border: "1px solid #e7eaf0"
};

const assignmentTourTitle = {
    fontSize: 14,
    fontWeight: 750,
    color: "#172033",
    marginBottom: 5
};

const assignmentTourDate = {
    fontSize: 12,
    color: "#536174",
    marginBottom: 8
};

const tourMetaRow = {
    display: "flex",
    alignItems: "center",
    gap: 6,
    fontSize: 12,
    color: "#536174",
    marginTop: 5
};

const progressBackground = {
    width: "100%",
    maxWidth: 260,
    height: 6,
    marginTop: 10,
    background: "#e7ebf0",
    borderRadius: 20,
    overflow: "hidden"
};

const progressBar = {
    height: "100%",
    background: "#c75028",
    borderRadius: 20
};

const tourFillText = {
    fontSize: 11,
    color: "#718096",
    marginTop: 4
};
